import * as React from 'react';
import { FallbackProps } from 'react-error-boundary';
import { ApiError } from '@collaborator/npm_modules/dist/modules/base/errors/ApiError';
import ErrorStackParser from 'error-stack-parser';
import stringify from 'json-stringify-pretty-compact';
import app from 'srcJs/App';
import { FC } from 'react';

const ErrorFallback: FC<FallbackProps> = ({ error }) => {
  const printError = () => {
    if (app.isProduction()) {
      return null;
    }

    const stackFrames = ErrorStackParser.parse(error).map((stackFrame) => (
      <li key={stackFrame.fileName + stackFrame.functionName}>
        {stringify(stackFrame)}
      </li>
    ));

    return (
      <div>
        <p>
          <span className="mr-1 font-weight-bold">
            Name:
          </span>
          {error.name}
        </p>
        <p>
          <span className="mr-1 font-weight-bold">
            Message:
          </span>
          {error.message}
        </p>
        <ul className="list-unstyled">
          {stackFrames}
        </ul>
      </div>
    );
  };

  if (error instanceof ApiError) {
    return (
      <div className="py-16p py-lg-0">
        <div className="container container-lg-fluid">
          <div className="alert alert-danger">
            <p className="mb-0">
              http error
            </p>
          </div>
          {printError()}
        </div>
      </div>
    );
  }

  return (
    <div className="py-16p py-lg-0">
      <div className="container container-lg-fluid">
        <div className="alert alert-danger">
          <p className="mb-0">
            Something went wrong:
          </p>
        </div>
        {printError()}
      </div>
    </div>
  );
};

export { ErrorFallback };
